const index = () => import(/* webpackChunkName: "herb" */ './Index');


//router.js
export default {
  routes: [
    {
      path: '/smes/v2023/index',
      name: 'smes_2023_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/V2023/router.js